


export function AssignablesShow() {
    return (
        <div>
            <h1>Assignables</h1>
        </div>
    )
}